import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { parseQuery } from '../utils/query';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: require("./en.json"),
    ru: require("./ru.json"),
    zh: require("./zh.json"),
    es: require("./es.json"),
};

const searchParams = parseQuery(window.location.search.substring(1));
const queryObj = searchParams;

if (window.location.hostname.indexOf("holla-africa") === 0) {
    localStorage.setItem('i18nextLng', 'en');
} else if (window.location.hostname.indexOf("realbet") === 0) {
    localStorage.setItem('i18nextLng', 'es');
}

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: queryObj.lang,
        fallbackLng: "en",
        keySeparator: ".",
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        react: {
            wait: false
        }
    });

export default i18n;